import { createApp } from "vue";
import { createPinia } from "pinia";

import App from "./App.vue";
import router from "./mixins/router";
import i18next from "./i18next";
import I18NextVue from "i18next-vue";
import { configStore } from "@/stores/config";

// @ts-ignore
import vSelect from "vue-select";
// @ts-ignore
import VueGridLayout from "vue-grid-layout";
import ApiConnection from "@/api";
import { connectionMonitor } from "@/api/monitor";
// vue-datepicker
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
//click-outside-vue3
// @ts-ignore
import vClickOutside from "click-outside-vue3";
import Vue3TouchEvents from "vue3-touch-events";

import overflowIndicator from "@/directives/overflowIndicator.js";
import markdownToolsDirective from "@/directives/markdownTools.js";

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.use(VueGridLayout);
app.use(vClickOutside);
app.use(Vue3TouchEvents);
app.component("v-select", vSelect);
app.component("VueDatePicker", VueDatePicker);

const config = configStore();
config.$subscribe((mutation, state) => {
  const locale: string = state?.config?.localization?.language_code || "";
  const list: string[] = Object.keys(i18next.services.resourceStore.data);
  if (locale && list.includes(locale)) {
    i18next.changeLanguage(locale);
  }
});
app.use(I18NextVue, { i18next });

app.directive("overflow-indicator", overflowIndicator);
app.directive("markdownTools", markdownToolsDirective);

app.mount("#app");

// @ts-ignore
window.UC = {
  app,
  api: ApiConnection,
  connectionMonitor,
};
